import { useState, useMemo } from "react";
import Text from "../../Text";
import Img from "../../Img";
import { getImg } from "../../../../../Components/Utils";

const ITEMS_PER_COL = 4;
const MAX_COLS = 4;
const GRID_COLS = ["", "grid-cols-1", "grid-cols-2", "grid-cols-3", "grid-cols-4"];

const resolveImg = (src) =>
  src?.startsWith("http") ? src : getImg(src);

const chunk = (arr, size) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

const NavDropdownWithImage = ({ visible, items, buildHref, seeAllHref }) => {
  const [hoveredImg, setHoveredImg] = useState(items[0]?.img);

  const columns = useMemo(
    () => chunk(items.slice(0, ITEMS_PER_COL * MAX_COLS), ITEMS_PER_COL),
    [items],
  );
  const colClass = GRID_COLS[columns.length] ?? "grid-cols-4";
  const hasImg = items.some((i) => i.img);

  return (
    <div className={visible ? "block" : "hidden"}>
      <div className="max-w-[1440px] mx-auto px-8 py-8 flex gap-10">
        <div className="flex-1 flex flex-col gap-4">
          <div className={`grid ${colClass} gap-x-8 gap-y-1`}>
            {columns.map((col, ci) => (
              <ul key={ci} className="flex flex-col gap-1">
                {col.map((item) => (
                  <li key={item.slug}>
                    <Text
                      is="a"
                      href={buildHref(item)}
                      className="text-sm text-gray-600 hover:text-blue-500 transition-colors py-1.5 flex items-center gap-2 group"
                      onMouseEnter={() => item.img && setHoveredImg(item.img)}
                    >
                      <span className="w-1 h-1 rounded-full bg-gray-300 group-hover:bg-blue-500 transition-colors flex-shrink-0" />
                      {item.label}
                    </Text>
                  </li>
                ))}
              </ul>
            ))}
          </div>
          <Text
            is="a"
            href={seeAllHref}
            className="w-fit text-xs font-semibold text-white bg-blue-500 hover:bg-blue-600 transition-colors px-4 py-2 rounded-full"
          >
            See all →
          </Text>
        </div>
        {hasImg && (
          <div className="w-[220px] flex-shrink-0 rounded-lg overflow-hidden aspect-[4/3]">
            {hoveredImg && (
              <Img
                src={resolveImg(hoveredImg)}
                alt=""
                className="w-full h-full object-cover transition-opacity duration-300"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NavDropdownWithImage;
